// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._8j8tsx0 {
  margin-bottom: var(--_18w76bwh);
}
._8j8tsx1 {
  overflow-x: scroll;
  scrollbar-width: none;
}
._8j8tsx1::-webkit-scrollbar {
  display: none;
}
._8j8tsx2 {
  position: relative;
  height: var(--_18w76bwc);
  background-color: var(--_18w76bw23);
  overflow: hidden;
  margin-left: -16px;
  margin-right: -16px;
}
._8j8tsx3 {
  position: absolute;
  margin-top: var(--_18w76bwa);
  height: var(--_18w76bwb);
  background-color: #C1C1C1;
  border-radius: var(--_18w76bwb);
  width: var(--_18w76bw1w);
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,wBAAwB;EACxB,yBAAyB;EACzB,+BAA+B;EAC/B,wBAAwB;AAC1B","sourcesContent":["._8j8tsx0 {\n  margin-bottom: var(--_18w76bwh);\n}\n._8j8tsx1 {\n  overflow-x: scroll;\n  scrollbar-width: none;\n}\n._8j8tsx1::-webkit-scrollbar {\n  display: none;\n}\n._8j8tsx2 {\n  position: relative;\n  height: var(--_18w76bwc);\n  background-color: var(--_18w76bw23);\n  overflow: hidden;\n  margin-left: -16px;\n  margin-right: -16px;\n}\n._8j8tsx3 {\n  position: absolute;\n  margin-top: var(--_18w76bwa);\n  height: var(--_18w76bwb);\n  background-color: #C1C1C1;\n  border-radius: var(--_18w76bwb);\n  width: var(--_18w76bw1w);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
